// extracted by mini-css-extract-plugin
export default {"spin":"_16rOP8gauGQHMnOt-V1woN"};